import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';
import { password } from 'Utils/validations';

const ChangePasswordFormSchema = Yup.object().shape(
  reverseShape({
    currentPassword: Yup.string().required().concat(  Yup.string()
    .matches(/^(?=.*\d)(?=.*[A-Z])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])[0-9a-zA-Z\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]+$/)
    .min(6)
    .max(12)
    .required()
),
    newPassword: Yup.string().required().concat(
      // password
      Yup.string()
        .matches(/^(?=.*\d)(?=.*[A-Z])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])[0-9a-zA-Z\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]+$/)
        .min(6)
        .max(12)
        .required()
    ),
    confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null]),
  })
)

export default ChangePasswordFormSchema;